import layout from 'apps/new-web/views/components/layout/reducers';
import notifications from 'apps/new-web/views/components/header/post-login-navigation/notifications-menu/reducers';
import postLoginNavigation from 'apps/new-web/views/components/header/post-login-navigation/reducers';
import profileImage from 'apps/new-web/views/components/header/post-login-navigation/profile-image/reducers';

export default {
  layout,
  notifications,
  postLoginNavigation,
  profileImage
};
